// extracted by mini-css-extract-plugin
export var printerCard = "_be-1";
export var printerCardConfigured = "_be-2";
export var printerCardError = "_be-3";
export var printerCardsContainer = "_be-0";
export var printerIcon = "_be-8";
export var printerIconConfigured = "_be-5";
export var printerIconContainer = "_be-4";
export var printerIconError = "_be-6";
export var printerIconUnconfigured = "_be-7";
export var workstationsTableCard = "_be-9";